const ShiftReportPage = () => {
  return (
    <div>
      <h1>Shift Report</h1>
    </div>
  );
};

export default ShiftReportPage;
